/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';

/**
 * 
 * @export
 * @interface CreateNumericListDto
 */
export interface CreateNumericListDto {
    /**
     * 
     * @type {string}
     * @memberof CreateNumericListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericListDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericListDto
     */
    groupId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericListDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericListDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericListDto
     */
    numericId?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateNumericListDto
     */
    values?: Array<number> | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof CreateNumericListDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericListDto
     */
    $type?: CreateNumericListDtoTypeEnum;
}


/**
 * @export
 */
export const CreateNumericListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateNumericListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateNumericListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateNumericListDtoTypeEnum = typeof CreateNumericListDtoTypeEnum[keyof typeof CreateNumericListDtoTypeEnum];



/**
 * Check if a given object implements the CreateNumericListDto interface.
 */
export function instanceOfCreateNumericListDto(value?: unknown): value is CreateNumericListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateNumericListDtoTypeEnum)[0];
}

export function CreateNumericListDtoFromJSON(json: any): CreateNumericListDto {
    return CreateNumericListDtoFromJSONTyped(json, false);
}

export function CreateNumericListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNumericListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'numericId': json['numericId'] == null ? undefined : json['numericId'],
        'values': json['values'] == null ? undefined : json['values'],
        'geometry': json['geometry'] == null ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateNumericListDtoToJSON(value?: CreateNumericListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'numericId': value['numericId'],
        'values': value['values'],
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value['geometry']),
        '$type': value['$type'],
    });
}

